import { MagnifyPlusIcon } from './MagnifyPlusIcon';

/**
 * author: Austin Andrews
 * id 798F7C9D-2EC7-47EF-8729-845B4E2DDD16
 * name magnify-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magnify-plus.svg
 * tags
 */
export const SearchPlusIcon = MagnifyPlusIcon;
export default SearchPlusIcon